import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import { Result, Button } from 'antd';

export default class ErrorPage extends Component {

  gotoHome = () => {
    this.props.history.push('/')
  }

  render() {
    return (
      <div className=".errorpage">
        <TopNav history={this.props.history} />
        <div className="errorpage-main">
          <Result
            status="404"
            title="404"
            subTitle="Ops, We can't find the page you're looking for!"
            extra={<Button size="large" type="primary" onClick={() => this.gotoHome()}>Back Home</Button>}
          />
        </div>
        <Footer />
      </div>
    )
  }
}
